<template>
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <b-tabs v-model="tab">
            <b-tab
              @click="newItem = {}"
              :title="$t('edu_contents.edu_contents')"
            >
              <contents />
            </b-tab>
            <b-tab
              @click="newItem = {}"
              :title="$t('edu_programs.assign_teachers')"
            >
              <assign-teachers />
            </b-tab>
            <b-tab
              @click="newItem = {}"
              :title="$t('edu_programs.assign_official_exams')"
            >
              <assign-official-exams />
            </b-tab>

            <b-tab
              @click="newItem = {}"
              :title="$t('edu_programs.publishing_settings')"
            >
              <add-starting-point />
            </b-tab>
          </b-tabs>
        </div>
        <!-- end of card body -->
      </div>
      <!-- end of card -->
    </div>
    <!-- end of col -->
  </div>
  <!-- end of row -->
</template>

<script>
import Discussions from "../Discussions/components/DataTable.vue";
import AddStartingPoint from "./components/AddStartingPoint.vue";
import AssignOfficialExams from "./components/AssignOfficialExams.vue";
import AssignTeachers from "./components/AssignTeachers.vue";
import Contents from "./Edu_contents.vue";

export default {
  name: "EduProgramsIndex",
  components: {
    AssignTeachers,
    AssignOfficialExams,
    Discussions,
    AddStartingPoint,
    Contents,
  },
  data() {
    return {
      newItem: {},
      tab: 0,
    };
  },
  methods: {},
};
</script>
